// src/components/NotFound.js
import React from "react";
import { Link } from "react-router-dom";
import styles from "./NotFound.module.scss";

export default function NotFound() {
  return (
    <div className={styles.notFound}>
      <h1>404</h1>
      <h2>Stranica nije pronađena</h2>
      <p>Izgleda da stranica koju tražiš ne postoji.</p>
      <Link to="/" className={styles.homeBtn}>
        Vrati se na početnu
      </Link>
    </div>
  );
}